import { observer } from 'inferno-mobx';
import { h } from 'inferno-hyperscript';

import STATE from '../app/state.js';

function Row(props) {
    let data = props.v;
    let unit = props.unit || '';
    
    if (!isNaN(parseInt(data))) {
        data = Math.round(data * 100) / 100;
    } else if (data == null || data == undefined || data === "") {
        data = "Inget värde";
        unit = '';
    }
    
    return h('tr', [
        h('th', props.k),
        h('td', `${data} ${unit}`)
    ]);
}

const FISKVAG = {
    1: 'Bassängtrappa',
    2: 'Denilränna',
    3: 'Slitsränna',
    4: 'Omlöp',
    5: 'Inlöp',
    6: 'Ålledare',
    7: 'Smoltränna',
    8: 'Okänd typ',
    9: 'Ingen fiskväg',
    10: 'Annan'
};

const STATUS = {
    1: 'Befintlig damm',
    2: 'Fd. damm'
};

const VERKSMHT = {
    1: 'Kraftproduktion',
    2: 'Industri',
    3: 'Sjöfart',
    4: 'Invallning',
    5: 'Vattenförsörjning',
    6: 'Spegeldamm',
    7: 'Historisk',
    8: 'Övrigt'
};

const REGL_TYP = {
    1: {
        1: 'Fast tröskel/Överfall',
        2: 'Reglerbart utskov',
        3: 'Intag',
        4: 'Spärrdamm/oreglerad'
    },
    2: {
        1: 'Raserad',
        2: 'Utriven',
        3: 'Okänt'
    }
};

const HOJD_SYS = {
    1: 'RH2000',
    2: 'Lokalt',
    3: 'RH70',
    4: 'RH00'
};

const DamInfoComponent = observer(function () {
    const dam = STATE.currentDam;
    
    if(dam === undefined) {
        return null;
    }
    
    const props = dam.properties;
    return h('section', [
        h('h1', props.NAMN || props.DNAMN),
        h('div.overflow-container', [
            h('table', { className: 'tableinfo' }, [
                h('tbody', [
                    h(Row, { k: 'Dammens identitet', v: props.DAMMID }),
                    h(Row, { k: 'N-koordinat', v: props.NORTH }),
                    h(Row, { k: 'E-koordinat', v: props.EAST }),
                    h(Row, { k: 'Vattenförekomstidentitet (EU_CD)', v: props.EU_CD }),
                    h(Row, { k: 'Dammenhetens namn', v: props.DNAMN }),
                    h(Row, { k: 'Kommun', v: props.KOMMUN }),
                    h(Row, { k: 'Inrapporterad av Länsstyrelse', v: props.INRAPP_LST }),
                    h(Row, { k: 'Status', v: STATUS[props.STATUS] || '' }),
                    h(Row, { k: 'År för första byggnation av dammenheten', v: props.BYGGAR || null }),
                    h(Row, { k: 'Identitet för eventuell dammanläggning dammenheten är kopplad till', v: props.DAMMANLID }),
                    h(Row, { k: 'Dammanläggningens namn', v: props.NAMN }),
                    h(Row, { k: 'Ombyggnadsår', v: props.OMBYGGAR || null }),
                    h(Row, { k: 'Högsta dämningsgräns (m) enligt tillstånd', v: props.DG || null, unit: 'm' }),
                    h(Row, { k: 'Lägsta sänkningsgräns (m) enligt tillstånd', v: props.SG || null, unit: 'm' }),
                    h(Row, { k: 'Höjdsystem som DG och SG räknats i', v: HOJD_SYS[props.HOJD_SYS] }),
                    h(Row, { k: 'Magasinsyta (km²) vid angiven DG', v: props.MY || null, unit: 'km²' }),
                    h(Row, { k: 'Reglerbar volym (milj. m³). Magasinets volym mellan DG och SG', v: props.RV || null, unit: 'miljoner m³' }),
                    h(Row, { k: 'Regleringstyp för befintlig damm', v: REGL_TYP[props.STATUS || {}][props.REGL_TYP]}),
                    h(Row, { k: 'Förekomst och typ av fiskväg vid dammenheten', v: FISKVAG[props.FISKVAG]}),
                    h(Row, { k: 'Verksamhet', v: VERKSMHT[props.VERKSMHT]})
                ])
            ])
        ])
    ]);
});

export { DamInfoComponent };
